import styled from "../../styled-components.js";
export var Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-g5kv67-0"
})(["min-inline-size:0;overflow-wrap:break-word;"]);